export default __webpack_public_path__ + "static/media/unsplash_image2.b5875c73.png";